import { TransactionDetail } from './data/useGetLimitDetail';

export const FIELDS: {
  label: string;
  getText: (trx: TransactionDetail) => string | number | boolean;
  name: keyof TransactionDetail;
  editable: boolean;
  type: string;
}[] = [
  {
    label: 'LIMITS:COLUMNS:TRANSACTION_TYPE',
    getText: (trx: TransactionDetail) => trx.transactionType,
    name: 'transactionType',
    editable: false,
    type: 'string',
  },
  {
    label: 'COMMON:SEGMENT',
    getText: (trx: TransactionDetail) => trx.segmentId,
    name: 'segmentId',
    editable: false,
    type: 'number',
  },
  {
    label: 'LIMITS:COLUMNS:DESCRIPTION',
    getText: (trx: TransactionDetail) => trx.description,
    name: 'description',
    editable: true,
    type: 'string',
  },
  {
    label: 'LIMITS:FIELDS:DOUBLE_FACTOR',
    getText: (trx: TransactionDetail) => trx.doubleFactor,
    name: 'doubleFactor',
    editable: true,
    type: 'boolean',
  },
  {
    label: 'LIMITS:FIELDS:TRANSACTION_LIMIT_RECEIVED',
    getText: (trx: TransactionDetail) => trx.transactionLimitReceived,
    name: 'transactionLimitReceived',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:DAILY_LIMIT_RECEIVED',
    getText: (trx: TransactionDetail) => trx.dailyLimitReceived,
    name: 'dailyLimitReceived',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:MONTHLY_LIMIT_RECEIVED',
    getText: (trx: TransactionDetail) => trx.monthlyLimitReceived,
    name: 'monthlyLimitReceived',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:DAILY_LIMIT_TX_RECEIVED',
    getText: (trx: TransactionDetail) => trx.dailyLimitTxReceived,
    name: 'dailyLimitTxReceived',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:MONTHLY_LIMIT_TX_RECEIVED',
    getText: (trx: TransactionDetail) => trx.monthlyLimitTxReceived,
    name: 'monthlyLimitTxReceived',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:TRANSACTION_LIMIT_SENT',
    getText: (trx: TransactionDetail) => trx.transactionLimitSent,
    name: 'transactionLimitSent',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:DAILY_LIMIT_SENT',
    getText: (trx: TransactionDetail) => trx.dailyLimitSent,
    name: 'dailyLimitSent',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:MONTHLY_LIMIT_SENT',
    getText: (trx: TransactionDetail) => trx.monthlyLimitSent,
    name: 'monthlyLimitSent',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:DAILY_LIMIT_TX_SENT',
    getText: (trx: TransactionDetail) => trx.dailyLimitTxSent,
    name: 'dailyLimitTxSent',
    editable: true,
    type: 'number',
  },
  {
    label: 'LIMITS:FIELDS:MONTHLY_LIMIT_TX_SENT',
    getText: (trx: TransactionDetail) => trx.monthlyLimitTxSent,
    name: 'monthlyLimitTxSent',
    editable: true,
    type: 'number',
  },
];

export const initialValues = {
  dailyLimitReceived: '0',
  dailyLimitSent: '0',
  dailyLimitTxReceived: '0',
  dailyLimitTxSent: '0',
  description: '',
  doubleFactor: false,
  monthlyLimitReceived: '0',
  monthlyLimitSent: '0',
  monthlyLimitTxReceived: '0',
  monthlyLimitTxSent: '0',
  transactionLimitReceived: '0',
  transactionLimitSent: '0',
};
